"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const class_validator_1 = require("class-validator");
async function validateCommonEvent(eventRequest) {
    const config = { skipMissingProperties: false };
    await validate(eventRequest, config);
}
exports.validateCommonEvent = validateCommonEvent;
async function validateCommonEventWithConfig(eventRequest, config) {
    await validate(eventRequest, config);
}
exports.validateCommonEventWithConfig = validateCommonEventWithConfig;
async function validate(eventRequest, config) {
    const errors = await class_validator_1.validate(eventRequest, config);
    if (errors && errors.length > 0) {
        throw errors;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@soluto-private/common-event/dist/src/validators/event.js